import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { Background } from "../../Background/Background";
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { VideoPlayer } from "../../Video/VideoPlayer/VideoPlayer";
import styles from "./VideoSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var videoSliceHeadlineTypogs = ['headline3', 'headline4'];
export var VideoSlice = function VideoSlice(_ref) {
  var _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? {
      text: '',
      variant: 'default'
    } : _ref$eyebrow,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? {
      text: '',
      typog: 'headline4'
    } : _ref$headline,
    videoPlayer = _ref.videoPlayer,
    background = _ref.background;
  return /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
    children: /*#__PURE__*/_jsx(Container, {
      className: styles.container,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        "data-e2e-name": "video_slice",
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.content,
          children: [(eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text) && /*#__PURE__*/_jsx(Text, {
            className: styles.eyebrow,
            typog: headline.typog === 'headline4' ? 'eyebrow3' : 'eyebrow2',
            variant: eyebrow.variant,
            children: eyebrow.text
          }), (headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(HeadingText, {
            ariaLevel: 2,
            className: styles.headline,
            typog: headline.typog,
            children: headline.text
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.container,
          children: /*#__PURE__*/_jsx("div", {
            className: styles.video,
            children: /*#__PURE__*/_jsx(VideoPlayer, _objectSpread({}, videoPlayer))
          })
        })]
      })
    })
  }));
};